import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import State from 'store/State.ts';

export type TradeDate = {
    index: number;
    date: number;
    flags: string[];
    notes: string;
};
export type TradeDatesState = {
    [symbol: string]: Array<TradeDate>;
};

export const initialTradeDatesState: TradeDatesState = {};

const tradeDatesSlice = createSlice({
    name: 'tradeDates',
    initialState: initialTradeDatesState,
    reducers: {
        addTradeDates: (
            state,
            action: PayloadAction<{
                symbol: string;
                tradeDates: Array<TradeDate>;
            }>
        ) => {
            const { symbol, tradeDates } = action.payload;
            const existing = state[symbol] || [];
            state[symbol] = [
                ...existing,
                ...tradeDates.filter(
                    (t) => !existing.find((e) => e.date === t.date)
                ),
            ];
        },
    },
});

export default tradeDatesSlice.reducer;

export const { addTradeDates } = tradeDatesSlice.actions;

export const selectTradeDatesState = (state: State) => state.tradeDates;
